import React from "react";
import {connect} from "react-redux";
import {Text, DropdownMenuItem} from "@reside/ui";

import {select, AppState} from "../../../../store";
import {ModalName, useDashboardModalContext} from "../../DashboardModalContext";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";

export const Renderer = ({
  admission,
  isResideAdmin,
}: {
  admission: AdmissionFromSearch;
  isResideAdmin: boolean;
}) => {
  const {toggleModal} = useDashboardModalContext(ModalName.FORCE_DELETE);

  if (!isResideAdmin) {
    return null;
  }

  return (
    <DropdownMenuItem
      onClick={() => toggleModal(admission)}
      testId="force-delete-admission"
    >
      <Text color="deepOrange100">Force Delete</Text>
    </DropdownMenuItem>
  );
};

const mapStateToProps = (state: AppState) => ({
  isResideAdmin: select.adminSession.isResideAdmin(state),
});

export const ForceDeleteAdmissionDropdownItem =
  connect(mapStateToProps)(Renderer);
